import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReviewStars } from '../review-stars';
import * as Styled from './review-card.style';

export type ReviewCardProps = {
  quoteKey: string;
  authorKey: string;
};

export const ReviewCard: React.FC<ReviewCardProps> = ({
  quoteKey,
  authorKey,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.ReviewCard>
      <ReviewStars />
      <Styled.ReviewQuote>{t(quoteKey)}</Styled.ReviewQuote>
      <Styled.ReviewAuthor>{t(authorKey)}</Styled.ReviewAuthor>
    </Styled.ReviewCard>
  );
};
